import Link from "next/link";
import { ChefHat, Mail } from "lucide-react";

export const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-orange-50 border-t border-orange-200 mt-16" dir="rtl">
            <div className="container mx-auto px-4 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {/* Brand Section */}
                    <div className="lg:col-span-1">
                        <Link href="/" className="flex items-center gap-2 text-2xl font-bold text-orange-600 mb-4">
                            <ChefHat className="h-8 w-8" />
                            <span>פידלי</span>
                        </Link>
                        <p className="text-gray-600 leading-relaxed">
                            יוצרים מתכונים טעימים ומזינים מהמצרכים שיש לכם בבית.
                            בישול פשוט, מהנה ומותאם אישית.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">קישורים מהירים</h3>
                        <div className="grid grid-cols-2 gap-x-6 gap-y-2">
                            <Link
                                href="/"
                                className="text-gray-600 hover:text-orange-600 transition-colors"
                            >
                                צור מתכון
                            </Link>
                            <Link
                                href="/cookbook"
                                className="text-gray-600 hover:text-orange-600 transition-colors"
                            >
                                ספר המתכונים
                            </Link>
                            <Link
                                href="/articles"
                                className="text-gray-600 hover:text-orange-600 transition-colors"
                            >
                                מאמרים
                            </Link>
                            <Link
                                href="/"
                                className="text-gray-600 hover:text-orange-600 transition-colors"
                            >
                                דף הבית
                            </Link>
                            <Link
                                href="/profile"
                                className="text-gray-600 hover:text-orange-600 transition-colors"
                            >
                                הפרופיל שלי
                            </Link>
                            <Link
                                href="/pricing"
                                className="text-gray-600 hover:text-orange-600 transition-colors"
                            >
                                תמחור
                            </Link>
                            <Link
                                href="/about"
                                className="text-gray-600 hover:text-orange-600 transition-colors"
                            >
                                אודותינו
                            </Link>
                            <Link
                                href="/contact"
                                className="text-gray-600 hover:text-orange-600 transition-colors"
                            >
                                צור קשר
                            </Link>
                            <Link
                                href="/faq"
                                className="text-gray-600 hover:text-orange-600 transition-colors"
                            >
                                שאלות נפוצות
                            </Link>
                            <a
                                href="https://www.instagram.com/feedly.co.il/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-gray-600 hover:text-orange-600 transition-colors"
                            >
                                אינסטגרם
                            </a>
                        </div>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">יצירת קשר</h3>
                        <div className="space-y-3">
                            <div className="flex items-center gap-3">
                                <div className="bg-orange-100 p-2 rounded-full">
                                    <Mail className="h-5 w-5 text-orange-600" />
                                </div>
                                <a
                                    href="mailto:feedlyservice@gmail.com"
                                    className="text-gray-600 hover:text-orange-600 transition-colors"
                                >
                                    feedlyservice@gmail.com
                                </a>
                            </div>
                            <Link
                                href="/contact"
                                className="text-gray-600 hover:text-orange-600 transition-colors block"
                            >
                                דף יצירת קשר
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Bottom Section */}
                <div className="border-t border-orange-200 mt-8 pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <div className="text-gray-600 text-sm">
                            © {currentYear} Feedly. כל הזכויות שמורות.
                        </div>
                        <div className="flex flex-wrap gap-6 text-sm">
                            <Link
                                href="/privacy-policy"
                                className="text-gray-600 hover:text-orange-600 transition-colors"
                            >
                                מדיניות פרטיות
                            </Link>
                            <Link
                                href="/terms-of-service"
                                className="text-gray-600 hover:text-orange-600 transition-colors"
                            >
                                תנאי שימוש
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};
